import moment from "moment";
import {
  Paper,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

//Common styles
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";

const CFPOrderSummary = ({ record }: { record: any }) => {
  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Order Summary</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Payment Type</TableHeader>
              <TableHeader>Date</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {record?.orders.length > 0 ? (
              record?.orders?.map((each: any) => (
                <CustomTableRowTR key={each.orderSummary}>
                  <TableData>{each?.orderSummary}</TableData>
                  <TableData>
                    {each?.payment?.razorpayOrder?.paymentDate
                      ? moment(
                          each?.payment?.razorpayOrder?.paymentDate,
                        ).format("DD-MM-YYYY hh:mm A")
                      : "-"}
                  </TableData>
                </CustomTableRowTR>
              ))
            ) : (
              <TableRow>
                <TableHeader colSpan={4} align="center">
                  No data available
                </TableHeader>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

export default CFPOrderSummary;
